import type {
  CompletePiiTrainingRequest,
  PiiTrainingAnswers,
  PiiTrainingStatus,
  PiiTrainingStatusResponse,
} from '@/types/piiTraining';

export const mapPiiTrainingStatus = (response: PiiTrainingStatusResponse): PiiTrainingStatus => ({
  required: response.required,
  completed: response.completed,
  completedAt: response.completed_at,
});

export const toCompletePiiTrainingRequest = (
  answers: PiiTrainingAnswers,
  completedAt: Date
): CompletePiiTrainingRequest => ({
  answers: {
    example1: answers.example1,
    example2: answers.example2,
    example3: answers.example3,
    completed_at: completedAt.toISOString(),
  },
});
